var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFlagIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4583 1.83341H2.25V0.416748H0.833333V13.1667H0.125V14.5834H2.95833V13.1667H2.25V9.62508H11.4583C11.6462 9.62508 11.8264 9.55045 11.9592 9.41762C12.092 9.28478 12.1667 9.10461 12.1667 8.91675V2.54175C12.1667 2.35389 12.092 2.17372 11.9592 2.04088C11.8264 1.90804 11.6462 1.83341 11.4583 1.83341ZM10.75 8.20842H2.25V3.25008H10.75V8.20842Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlagIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/flag-icon.c75765bf28ab0a067fb303cd695fb6c9.svg";